<template>
  <div
    class="bg-white rounded border border-grey-300 overflow-hidden shadow mt-4"
    id="currentNavigation"
    v-if="
      selectedPotsHierarchyData[0] != undefined &&
      selectedPotsHierarchyData[0].default == 0
    "
  >
    <div class="w-full bg-white h-auto">
      <div class="border-b border-grey-300 px-5 py-4">
        <div class="flex justify-between items-center">
          <p class="text-md text-dark font-semibold" id="current_parent_name">
            {{ selectedPotsHierarchyData[0].name }}
          </p>
        </div>
      </div>
      <!-- <div id="navcontent1" class="py-2"></div> -->
      <div v-for="(post, p) in selectedPotsHierarchyData" :key="p">
        <p
          @click="pageClick(post.id)"
          v-if="p !== 0 && post.isAccess"
          :class="
            post.isSelected
              ? 'text-pink border-l-4 px-4 py-3 border-pink font-semibold'
              : 'text-sm text-dark px-5 py-3 font-semibold text-sm cursor-pointer'
          "
        >
          {{ post.name }}
        </p>
        <div
          v-else-if="p !== 0 && !post.isAccess"
          class="post-link display-none text-grey-500 ml-5 p-1 mt-1 flex flex-row cursor-default justify-between"
        >
          <div>
            {{ post.name }}
          </div>
          <div class="mr-2">
            <i class="fa fa-lock" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CurrentHierarchy',
  props: ['selectedPotsHierarchyData', 'changePage'],
  methods: {
    pageClick(id) {
      this.changePage(id);
    },
  },
};
</script>